export default __webpack_public_path__ + "static/media/sucessTick.148d1f48.svg";